// import node module libraries
import { Col, Row, Card } from 'react-bootstrap';

const Version_00_00_03 = () => {
	return (
		<Row>
			<Col lg={12} md={12} sm={12}>
				<Card>
					<Card.Body>
						<Row className="g-0">
							<Col lg={3} md={4} sm={12}>
								<div id="initial">
									<h5 className="mb-3 fwsemi--bold">
										<code>v0.0.3</code> - 18 Feb. 2025
									</h5>
								</div>
							</Col>
							<Col lg={9} md={8} sm={12}>
								<div>
									<h4 className="mb-1 fw-semi-bold">Basisfunktionen erweitert</h4>
									<ul>
										<li>
											Dashboardstatistiken hinzugefügt
										</li>
										<li>
											Basisfunktionalitäten für Benutzer hinzugefügt
										</li>
										<li>
											Basisfunktionalitäten für Firmenadministrator hinzugefügt
										</li>
										<li>
											Spracheinstellungen hinzugefügt
										</li>
										<li>
											Kleine Fehlerkorrekturen und Optimierungen im Frontend
										</li>
									</ul>
									<div className="mb-3">
										<h4>Dashboardstatistiken:</h4>
										<ul>
											<li>
												Neu - Basisauswertung für Flows
												<br />
											</li>
											<li>
												Neu - Demo Modus
												<br />
											</li>
										</ul>
									</div>
									<div className="mb-3">
										<h4>Basisfunktionalitäten für Benutzer:</h4>
										<ul>
											<li>
												Neu - Registrierung
												<br />
											</li>
											<li>
												Neu - Passwort ändern
												<br />
											</li>
											<li>
												Neu - Profil aktualisieren
												<br />
											</li>
										</ul>
									</div>
									<div className="mb-3">
										<h4>Basisfunktionalitäten für Firmenadministrator:</h4>
										<ul>
											<li>
												Neu - Rechnungsanschrift aktualisieren
												<br />
											</li>
											<li>
												Neu - Benutzer verwalten
												<br />
											</li>
										</ul>
									</div>
									<div className="mb-3">
										<h4>Spracheinstellungen:</h4>
										<ul>
											<li>
												Neu - Deutsch
												<br />
											</li>
											<li>
												Neu - Englisch
												<br />
											</li>
										</ul>
									</div>
								</div>
							</Col>
						</Row>
					</Card.Body>
				</Card>
			</Col>
		</Row>
	);
};

export default Version_00_00_03;
